import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import styles from "./index.module.css";
import { getInvoiceDocumentIdentity } from "../../../utils/invoiceDeposits";

const LOGO = "https://elitepromomarketing.com/wp-content/uploads/2024/08/logo-1-600x183.png";

const Header = ({ invoiceDetails, headerConfig }) => {
  const title = headerConfig?.companyName || "Elite Promotional Marketing";
  const resolvedLogo = headerConfig?.logoUrl || LOGO;
  const documentIdentity = getInvoiceDocumentIdentity(invoiceDetails);
  const invoiceMetaLine = `${documentIdentity.numberLabel}${invoiceDetails?.id ?? "N/A"}`;
  const projectMetaLine = String(invoiceDetails?.projectName || "").trim() || "Promotional Items";
  const headerStyle = {
    backgroundImage: headerConfig?.backgroundUrl ? `url('${headerConfig.backgroundUrl}')` : undefined,
    backgroundColor: headerConfig?.backgroundColor || undefined,
  };

  return (
    <>
      <Grid container className={`${styles.headerContainer} ${styles.screenOnly}`} style={headerStyle}>
        <Grid item xs={1.5} className={styles.headerLogoContainer}>
          <img src={resolvedLogo} className={styles.headerLogo} alt="Logo" />
        </Grid>

        <Grid item xs={5} className={styles.TitleContainer}>
          <Box className={styles.titleContent}>
            <Typography variant="h4" gutterBottom color="white">
              {title}
            </Typography>

            <Typography variant="body1" color="white">
              {invoiceMetaLine}
              <br />
              {projectMetaLine}
            </Typography>
          </Box>
        </Grid>

        <Grid item className={`${styles.rightBar} ${styles.rightAbsolute}`}>
          <Box className={styles.rightBarInner} />
        </Grid>
      </Grid>

      <header className={styles.printOnly}>
        <div className={styles.printBrandRow}>
          <div className={styles.printLogoColumn}>
            <img src={resolvedLogo} alt={`${title} logo`} />
          </div>
          <div className={styles.printDocumentIdentity}>
            <h1>{title}</h1>
            <div>{invoiceMetaLine}</div>
            <div>{projectMetaLine}</div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
